import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../../../../types/csvUploadConfiguration';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { Routing } from '../../../../../../../util/routes.util';
import { Breadcrumbs, Crumb } from '../../../../../../components/Breadcrumbs';
import CsvUploadConfigurationsScreen from '../../../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import CsvUploadConfigurationUpdatePane from '../../../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import { Tab, Tabs } from '../../../../../../components/Tabs';
import CreateReorderRuleExportConfigurationPane from '../../../../../Common/ReorderRules/Settings/Export/Panes/CreateReorderRuleExportConfigurationPane';
import UpdateReorderRuleExportConfigurationPane from '../../../../../Common/ReorderRules/Settings/Export/Panes/UpdateReorderRuleExportConfigurationPane';
import ReorderRuleReportPane from '../../../../../Common/ReorderRules/Settings/ReorderRuleReportPane';

export default function ReorderRuleSettingsScreen() {
  const navigate = useNavigate();

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <Crumb text={t(TranslationKey.referenceData).singular.upper} path={Routing.productMasterData.overview()} />
        <Crumb
          text={t(TranslationKey.stockTriggers).singular.upper}
          path={Routing.productMasterData.settings.stockTriggers.overview()}
        />
        <Crumb
          current
          text={t(TranslationKey.settings).singular.upper}
          path={Routing.productMasterData.settings.stockTriggers.settings.importConfigurations.overview()}
        />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            text={t(TranslationKey.importConfigurations).singular.label}
            path={Routing.productMasterData.settings.stockTriggers.settings.importConfigurations.overview()}
            key={'import_configurations'}
          />
          <Tab
            text={t(TranslationKey.reporting).singular.label}
            path={Routing.productMasterData.settings.stockTriggers.settings.report.overview()}
            key={'reporting'}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path='report/create' element={<CreateReorderRuleExportConfigurationPane />} />
            <Route path='report/update/:id' element={<UpdateReorderRuleExportConfigurationPane />} />
            <Route path='report' element={<ReorderRuleReportPane />} />

            <Route
              path={'import_configurations/*'}
              element={
                <CsvUploadConfigurationsScreen
                  type={CsvUploadType.reorderRuleProduct}
                  backPath={Routing.productMasterData.settings.stockTriggers.overview()}
                />
              }
            />
            <Route
              path={'import_configurations/update/:id/*'}
              element={
                <CsvUploadConfigurationUpdatePane
                  type={CsvUploadType.reorderRuleProduct}
                  onDone={() => navigate('import_configurations')}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}
